﻿import { ActivityCard } from "../../components/activities/ActivityCard";
import type { ActivityGridComponent } from "../../types";
import { resolveLinkHref } from "../../utils/links";

/** Activity card grid renderer with images and links. */
export function ActivityGridRenderer({ component }: { component: ActivityGridComponent }) {
  const { items, compact = false } = component.content;
  return (
    <section className="grid items-stretch pt-4 gap-4 sm:gap-6 md:grid-cols-3">
      {items.map((a, idx) => (
        <ActivityCard
          key={`${resolveLinkHref(a.href) || a.title || "activity"}-${idx}`}
          title={a.title}
          description={a.description}
          href={a.href}
          imageSrc={(a as any).imageSrc}
          imageAlt={(a as any).imageAlt}
          compact={compact}
        />
      ))}
    </section>
  );
}


